import { translate } from './translations/i18n';
import { BACKGROUND_PATTERNS } from './background-patterns';
import { ON_NEW_MESSAGE } from './behaviour';
import { RESPONSE_TIME } from './response-time';
import { ChatIcons, ChatThumbnailType, MinimizedChatLayouts, } from './types/chat-settings';
var chatInstalledDate;
export var setChatInstallationDate = function (date) {
    if (typeof date === 'number') {
        chatInstalledDate = date;
    }
    else {
        throw new Error('Date must be an epoch millis number');
    }
};
export var DEFAULT_CHAT_SETTINGS_TEXTS = {
    get onlineTitle() {
        return translate('online.title');
    },
    get onlineMessage() {
        return translate('online.message');
    },
    get offlineTitle() {
        return translate('offline.title');
    },
    get offlineMessage() {
        return translate('offline.message');
    },
    get offlineChatMessage() {
        return translate('offline.chatMessage');
    },
    get messageTextBox() {
        return translate('message.textBox');
    },
};
// TODO CHAT-5469 to prevent exceeding 1k public data size
//  we should kill this fn after the 1k limit is increased
var getTextsWithoutNewDefaults = function () { return ({
    get onlineTitle() {
        return DEFAULT_CHAT_SETTINGS_TEXTS.onlineTitle;
    },
    get onlineMessage() {
        return DEFAULT_CHAT_SETTINGS_TEXTS.onlineMessage;
    },
    get offlineTitle() {
        return DEFAULT_CHAT_SETTINGS_TEXTS.offlineTitle;
    },
    get offlineMessage() {
        return DEFAULT_CHAT_SETTINGS_TEXTS.offlineMessage;
    },
    get offlineChatMessage() {
        return DEFAULT_CHAT_SETTINGS_TEXTS.offlineChatMessage;
    },
}); };
var design = {
    selectedImageOption: '2',
    selectedRadiusOption: '8',
    selectedBorderWidth: 1,
    selectedBorderColor: '#EEEEEE',
    selectedBackgroundPattern: BACKGROUND_PATTERNS.NONE.key,
    selectedBackgroundPatternOpacity: 10,
    minimizedChatLayout: MinimizedChatLayouts.Fixed,
    chatIcon: ChatIcons.SquareFilled,
    chatThumbnailType: ChatThumbnailType.Icon,
    customImg: [],
    displayChatIcon: true,
    headerDisplayLogo: false,
};
var layout = {
    collapsedAsRounded: false,
    position: '1',
};
export var DEFAULT_CHAT_SETTINGS = {
    WindowPosition: {
        BOTTOM_RIGHT: '1',
        BOTTOM_LEFT: '2',
    },
    texts: getTextsWithoutNewDefaults(),
    design: design,
    layout: layout,
    get behaviour() {
        return {
            onNewMessage: ON_NEW_MESSAGE.EXPAND,
            responseTimeEnabled: getFieldValue('responseTimeEnabled'),
            responseTimeSelected: RESPONSE_TIME.ASAP,
            pagesWithChat: ['*'],
        };
    },
};
var dateFor = function (year, month, day) {
    return new Date(year, month - 1, day);
};
var features = {
    responseTimeEnabled: {
        openDate: dateFor(2019, 11, 10),
        afterValue: true,
        beforeValue: false,
    },
};
var getFieldValue = function (fieldName) {
    var _a = features[fieldName], openDate = _a.openDate, afterValue = _a.afterValue, beforeValue = _a.beforeValue;
    return chatInstalledDate === 0 || chatInstalledDate > openDate.valueOf()
        ? afterValue
        : beforeValue;
};
//# sourceMappingURL=default-chat-settings.js.map